
export class utilsApps {
  public padTo2Digits(num: number) {
    return num.toString().padStart(2, '0');
  }
  //YYYY-MM-DD
  public formatDate(date: Date) {
    if (date != null && date.toString() !== '') {
      return [
        date.getFullYear(),
        this.padTo2Digits(date.getMonth() + 1),
        this.padTo2Digits(date.getDate()),
      ].join('/');
    } else {
      return null;
    }
  }


  public fnDateToString(date: Date, separador: string = "") {

    let _separador = separador;
    if (date != null && date.toString() !== '') {
      return [
        date.getFullYear(),
        this.padTo2Digits(date.getMonth() + 1),
        this.padTo2Digits(date.getDate()),
      ].join(_separador);
    } else {
      return null;
    }
  }

  //DD-MM-YYYY
  public formatDate2(date: Date) {
    if (date != null && date.toString() !== '') {
      return [
        this.padTo2Digits(date.getDate()),
        this.padTo2Digits(date.getMonth() + 1),
        date.getFullYear(),
      ].join('/');
    } else {
      return null;
    }
  }

  public fnNow(month: number = 0) {
    let _date = new Date();
    _date.setDate(_date.getDate() + month);
    return _date;
  }
  public fnAddDays(days: number = 0) {
    let _date = new Date();
    _date.setDate(_date.getDate() + days);
    return _date;
  }

  public fnAddDaysToDate(_date: Date, days: number = 0) {
    //let _date = new Date();
    _date.setDate(_date.getDate() + days);
    return _date;
  }

  public fnAddMinn(_now: Date, _min: number) {
    let newDateObj = new Date();
    return newDateObj.setTime(_now.getTime() + (_min * 60 * 1000));
  }


  public getDateFromString(data: string, formatSource: string = 'DD/MM/YYYY') {

    let newDate = new Date();
    if (formatSource == 'YYYY-MM-DD' && data.length >= 10) {
      newDate = new Date(
        data.split('-')[2] + '-' + data.split('-')[1] + '-' + data.split('-')[0]
      );
    }
    if (formatSource == 'DD/MM/YYYY' && data.length >= 10) {
      newDate = new Date(
        data.split('/')[2] + '/' + data.split('/')[1] + '/' + data.split('/')[0]
      );
    }
    return newDate;
  }

  public getDateInitMonth() {
    let currentDate = new Date();
    return new Date(
      currentDate.getFullYear() + '/' + (currentDate.getMonth() + 1) + '/01'
    );
  }
  //data es el response  blob de un pdf 
  public downloadFileBlob(data: any, name: string, extension: string) {
    let _blob = data;
    const a = document.createElement('a');
    const objectUrl = URL.createObjectURL(_blob);
    a.href = objectUrl;
    a.download = name + extension;
    a.click();
    URL.revokeObjectURL(objectUrl);
  }

  public b64toBlob(b64Data, contentType) {
    contentType = contentType || '';
    let sliceSize = 512;

    let byteCharacters = atob(b64Data);
    let byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      let slice = byteCharacters.slice(offset, offset + sliceSize);
      let byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      let byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    let blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }


  downloadFileFromB64(contentType: string, fileName: string, extension: string) {
    let _blob = this.b64toBlob(contentType, extension);
    const a = document.createElement('a');
    const objectUrl = URL.createObjectURL(_blob);
    a.href = objectUrl;
    a.download = fileName + extension;
    a.click();
    URL.revokeObjectURL(objectUrl);
  }

  public blobToBase64(blob) {
    return new Promise((resolve, _) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  }

  public disableBack() {
    window.history.pushState(null, null, window.location.href);
    window.onpopstate = function () {
      window.history.go(1);
    };
  }

  public GetTimeZoneOffset(full: boolean = false) {

    const date = new Date();
    const offsetMinutes = date.getTimezoneOffset();
    const hours = Math.floor(Math.abs(offsetMinutes) / 60);
    const minutes = Math.abs(offsetMinutes) % 60;
    const sign = offsetMinutes > 0 ? '-' : '+';
    let timeZoneOffset = '';
    if (full)
      timeZoneOffset = `UTC${sign}${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
    else
      timeZoneOffset = `${sign}${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`

    return timeZoneOffset;
  }

}
